var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-bar" }, [
    _c(
      "div",
      { staticClass: "filters-mobile" },
      [
        _c(
          "dropdown",
          {
            staticClass: "filters hidden-md hidden-lg",
            attrs: { title: "Expedition Filters", "container-class": "row" }
          },
          _vm._l(_vm.filterGroupNames, function(title, id) {
            return _vm.filters[id]
              ? _c(
                  "dropdown",
                  {
                    key: id,
                    staticClass: "filter col-xs-6",
                    attrs: { title: title }
                  },
                  [
                    _c("filter-checkbox-group", {
                      attrs: { checkboxes: _vm.filters[id], filter: id }
                    })
                  ],
                  1
                )
              : _vm._e()
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filters-desktop" },
      [
        _c("h1", { staticClass: "hidden-xs hidden-sm" }, [
          _vm._v("Cruise Search")
        ]),
        _vm._v(" "),
        _vm._l(_vm.filterGroupNames, function(title, id) {
          return _vm.filters[id]
            ? _c(
                "dropdown",
                {
                  key: id,
                  staticClass: "filter hidden-xs hidden-sm col-md-3",
                  attrs: { title: title }
                },
                [
                  _c("filter-checkbox-group", {
                    attrs: { checkboxes: _vm.filters[id], filter: id }
                  })
                ],
                1
              )
            : _vm._e()
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }